import { helpers, selectors } from 'app-webtech-core';
import { ccMenuSetIndex } from 'app-modules/player/actions';
import { CHARACTERS } from './types';

const remoteControllerCharactersButtonAction = helpers.actions.actionCreator(CHARACTERS);

export const remoteControllerCharactersButtonThunkAction = (payload) => async (
  dispatch,
  getState,
) => {
  await dispatch(remoteControllerCharactersButtonAction());
  const state = getState();
  const { isCCMenuOpen, currentCCMenu } = selectors.player.properties(state);

  // checks to see if the cc settings menu is open
  if (isCCMenuOpen) {
    // grabs the index of the menu item that has the character as it's 1st letter
    const menuIndex = helpers.getCCIndexFromCharacter(currentCCMenu, payload);
    if (menuIndex > -1) {
      dispatch(ccMenuSetIndex(menuIndex));
    }
  }
};
